FitnessMarkStudentDashboard = new (function () {
  this.setSelects = () => {
    let wrapper = ".fitness-marks-block";

    if (!$(wrapper) || !$(wrapper).length) return;

    $("#cohort", wrapper).select2({
      minimumResultsForSearch: Infinity,
      allowClear: false,
    });

    $("#date", wrapper).select2({
      minimumResultsForSearch: Infinity,
    });

    $("#fitness_marks_student_results_cohort_form", wrapper).submit();
  };
})();
